<template>
  <vx-card title="Period">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getAllPeriodLookup"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Payment Mode</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].periodId">
                      {{ data[indextr].periodId }}
                    </vs-td>
                    <vs-td :data="data[indextr].periodCode">
                      {{ data[indextr].periodCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].periodName">
                      {{ data[indextr].periodName }}
                    </vs-td>
                    <vs-td :data="data[indextr].paymentModeId">
                      {{
                        paymentMode(data[indextr].paymentModeId).paymentModeName
                      }}
                    </vs-td>

                    <!-- <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].periodId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(data[indextr].periodId)
                          "
                        />
                      </div>
                    </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      period: {
        periodId: 1,
        periodCode: "",
        periodName: "",
        paymentModeId: 1,
      },
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllPeriodLookup").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("lookup/getAllPaymentModeLookup").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getAllPeriodLookup() {
      return this.$store.state.lookup.getAllPeriodLookup;
    },
    paymentModeName: {
      get() {
        return this.$store.getters["lookup/paymentModeLookup"](
          this.period.PaymentModeId
        );
      },
      set(obj) {
        this.period.PaymentModeId = obj.PaymentModeId;
      },
    },
    paymentMode() {
      return (id) => this.$store.getters["lookup/paymentModeLookup"](id);
    },
  },
};
</script>
